import { star } from './star.js';
import { Toast } from 'mint-ui';
export default {
    props: {
        cid: String
    },
    data() {
        return {
            starList: star,
            starIndex: 4,
            starText: '',
            feedbackNum: '',
            feedbackText: '',
            feedbackDisabled: false,
        }
    },
    mounted() {
        this.starText = this.starList[this.starIndex].text;
        this.feedbackNum = this.starList[this.starIndex].value;
    },
    methods: {
        toggleEvaluate() {
            this.$parent.toggleEvaluate();
        },
        /**
         * 评价
         * @param { Object } item      list
         * @param { Number } index     索引值
         */
        giveStar(item,index) {
            this.starIndex = index;
            this.starText = item.text;
            this.feedbackNum = item.value;
        },
        async feedback() {
            this.feedbackDisabled = true;
            let res = await this.$http.post('/feedback', {
                cid: this.cid,
                feedback: this.feedbackNum,
                feedbackText: this.feedbackText
            });
            this.feedbackDisabled = false;
            if(!res) return;
            Toast('感谢您的评价');
            this.$parent.toggleEvaluate();
        }
    },
}


// WEBPACK FOOTER //
// ./src/pages/webot/evaluate/_evaluate.js